<div class="modal-header">
  <h5 class="modal-title" id="modal-basic-title">
    {{ titleModal | translate }}
  </h5>
  <button type="button" class="btn-close" (click)="closeModal()"></button>
</div>

<div class="modal-body">
  <div class="row align-items-stretch">
    <div class="col-md-6 col-lg-6 mb-2">
      <div class="card p-3 mb-3 border h-100">
        <div
          class="d-flex justify-content-between align-items-start mb-2 info-item"
        >
          <div class="d-flex align-items-center gap-2">
            <p class="card-title fw-semibold mb-0">
              {{ 'reports.bonus.bonusInformation' | translate }}
            </p>
          </div>
          <span class="card-title fw-medium">
            <i class="fa fa-gift fs-6"></i>
          </span>
        </div>

        <div class="row">
          <div class="col-4 info-item">
            <p class="mb-1 fw-medium">
              {{ 'reports.bonus.bonusName' | translate }}
            </p>
          </div>
          <div class="col-8 text-end info-item">
            <p class="mb-1 fw-normal">
              {{ bonusReportInfo?.bonusName }}
            </p>
          </div>

          <div class="col-4 info-item">
            <p class="mb-1 fw-medium">
              {{ 'reports.bonus.code' | translate }}
            </p>
          </div>
          <div class="col-8 text-end info-item">
            <p class="mb-1 fw-normal">
              {{ bonusReportInfo?.bonusCode }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-1 fw-medium">
              {{ 'reports.bonus.typeBonus' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-1 fw-normal">
              {{ bonusReportInfo?.typeBonus }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-1 fw-medium">
              {{ 'reports.bonus.product' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-1 fw-normal">
              {{ bonusReportInfo?.product || 'words.none' | translate }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-1 fw-medium">
              {{ 'reports.transactions.currencyId' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-1 fw-normal">
              {{ bonusReportInfo?.currecyCode }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-1 fw-medium">
              {{ 'reports.bonus.bonusAmount' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-1 fw-normal">
              $
              {{ bonusReportInfo?.amount ? bonusReportInfo?.amount : '00.00' }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-0 fw-medium">
              {{ 'reports.bonus.createdAt' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-0 fw-normal">
              {{
                bonusReportInfo?.bonusCreationDate
                  | date : FORMAT_FOR_DATES_LONG
              }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-0 fw-medium">
              {{ 'reports.bonus.claimDate' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-0 fw-normal">
              {{
                bonusReportInfo?.bonusClaimDate | date : FORMAT_FOR_DATES_LONG
              }}
            </p>
          </div>

          <div class="col-6">
            <p class="mb-0 fw-medium">
              {{ 'reports.bonus.acceptanceDate' | translate }}
            </p>
          </div>
          <div class="col-6 text-end">
            <p class="mb-0 fw-normal">
              {{
                bonusReportInfo?.activationDate | date : FORMAT_FOR_DATES_LONG
              }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-6 mb-2">
      <div class="card p-3 mb-3 border h-100">
        <div
          class="d-flex justify-content-between align-items-start mb-2 info-item"
        >
          <div class="d-flex align-items-center gap-2">
            <p class="card-title fw-semibold mb-0">
              {{ 'reports.bonus.playerInformation' | translate }}
            </p>
          </div>
          <span class="card-title fw-medium">
            <i class="fa fa-solid fa-user fs-6"></i>
          </span>
        </div>

        <div class="row">
          <div class="col-4 info-item">
            <p class="mb-1 fw-medium">
              {{ 'financial.holders.player' | translate }}
            </p>
          </div>
          <div class="col-8 text-end info-item">
            <p class="mb-1 fw-normal">
              {{ bonusReportInfo?.playerUsername }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-1 fw-medium">
              {{ 'reports.casino.playerId' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-1 fw-normal">
              {{ bonusReportInfo?.externalPlayerId }}
            </p>
          </div>

          <div class="col-5 info-item">
            <p class="mb-0 fw-medium">
              {{ 'reports.bonus.playerCategory' | translate }}
            </p>
          </div>
          <div class="col-7 text-end info-item">
            <p class="mb-0 fw-normal">
              {{ bonusReportInfo?.playerCategory }}
            </p>
          </div>

          <div class="col-4">
            <p class="mb-1 fw-medium">
              {{ 'reports.bonus.playerBonusId' | translate }}
            </p>
          </div>
          <div class="col-8 text-end">
            <p class="mb-1 fw-normal">
              {{ bonusReportInfo?.playerPromotionalCodeId }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-6 mb-2">
      <div class="card p-3 mb-3 border h-100">
        <div
          class="d-flex justify-content-between align-items-start mb-2 info-item"
        >
          <div class="d-flex align-items-center gap-2">
            <p class="card-title fw-semibold mb-0">
              {{ 'reports.bonus.financialInformation' | translate }}
            </p>
          </div>

          <span class="card-title fw-medium">
            <i class="fa fa-bank fs-6"></i>
          </span>
        </div>

        <div class="row">
          <div class="col-4 info-item">
            <p class="mb-1 fw-medium">
              {{ 'reports.bonus.wasDeposit' | translate }}
            </p>
          </div>
          <div class="col-8 text-end info-item">
            <div class="d-flex justify-content-end align-items-center gap-2">
              <span
                class="item rounded-circle"
                [ngClass]="
                  bonusReportInfo?.wasDeposit ? 'bg-success' : 'bg-danger'
                "
                style="width: 12px; height: 12px; display: inline-block"
              ></span>
              <p class="mb-0 fw-normal">
                {{
                  bonusReportInfo?.wasDeposit ?? false
                    | booleanToYesNo
                    | translate
                }}
              </p>
            </div>
          </div>

          <div class="col-6 info-item">
            <p class="mb-1 fw-medium">
              {{ 'words.amountDeposited' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-1 fw-normal">
              $
              {{
                bonusReportInfo?.amountDeposited
                  ? bonusReportInfo?.amountDeposited
                  : '00.00'
              }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-1 fw-medium">
              {{ 'reports.bonus.amountBonusPaid' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-1 fw-normal">
              $
              {{
                bonusReportInfo?.amountBonusPaid
                  ? bonusReportInfo?.amountBonusPaid
                  : '00.00'
              }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-1 fw-medium">
              {{ 'reports.bonus.amountBonusGenerated' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-1 fw-normal">
              $
              {{
                bonusReportInfo?.amountBonusGenerated
                  ? bonusReportInfo?.amountBonusGenerated
                  : '00.00'
              }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-1 fw-medium">
              {{ 'reports.bonus.bonusStatus' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-1 fw-normal">
              {{ bonusReportInfo?.state?.[_lang.code.value] || 'words.none' | translate }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-0 fw-medium">
              {{ 'reports.bonus.stateResult' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-0 fw-normal">
              {{
                bonusReportInfo?.result?.[_lang.code.value] || 'words.none' | translate
              }}
            </p>
          </div>

          <div class="col-6">
            <p class="mb-0 fw-medium">
              {{ 'reports.bonus.dateOfResult' | translate }}
            </p>
          </div>
          <div class="col-6 text-end">
            <p class="mb-0 fw-normal">
              {{
                bonusReportInfo?.resultDate
                  ? (bonusReportInfo?.resultDate | date : FORMAT_FOR_DATES_LONG)
                  : ('words.none' | translate)
              }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-6 mb-2">
      <div class="card p-3 mb-3 border h-100">
        <div
          class="d-flex justify-content-between align-items-start mb-2 info-item"
        >
          <div class="d-flex align-items-center gap-2">
            <p class="card-title fw-semibold mb-0">
              {{ 'reports.bonus.agentInformation' | translate }}
            </p>
          </div>

          <span class="card-title fw-medium">
            <i class="fa fa-key fs-6"></i>
          </span>
        </div>

        <div class="row">
          <div class="col-4 info-item">
            <p class="mb-1 fw-medium">
              {{ 'reports.bonus.agency' | translate }}
            </p>
          </div>
          <div class="col-8 text-end info-item">
            <p class="mb-1 fw-normal">
              {{ bonusReportInfo?.agentName }}
            </p>
          </div>

          <div class="col-6">
            <p class="mb-1 fw-medium">
              {{ 'reports.bonus.agentExternalId' | translate }}
            </p>
          </div>
          <div class="col-6 text-end">
            <p class="mb-1 fw-normal">
              {{ bonusReportInfo?.agentExternalId }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-lg-12">
      <div class="card p-3 mb-3 border h-100">
        <div
          class="d-flex justify-content-between align-items-start mb-2 info-item"
        >
          <div class="d-flex align-items-center gap-2">
            <p class="card-title fw-semibold mb-0">
              {{ 'reports.bonus.administrativeHistory' | translate }}
            </p>
          </div>
          <span class="card-title fw-medium">
            <i class="fa fa-history fs-6"></i>
          </span>
        </div>

        <div class="row">
          <div class="col-6 info-item">
            <p class="mb-0 fw-medium">
              {{ 'reports.bonus.createdByFullName' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-0 fw-normal">
              {{
                bonusReportInfo?.createdByFullName &&
                bonusReportInfo?.createdByFullName?.trim() !== ''
                  ? bonusReportInfo?.createdByFullName
                  : ('words.none' | translate)
              }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-0 fw-medium">
              {{ 'reports.bonus.modifiedByFullName' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-0 fw-normal">
              {{
                bonusReportInfo?.modifiedByFullName &&
                bonusReportInfo?.modifiedByFullName?.trim() !== ''
                  ? bonusReportInfo?.modifiedByFullName
                  : ('words.none' | translate)
              }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-0 fw-medium">
              {{ 'reports.bonus.activatedByFullName' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-0 fw-normal">
              {{
                bonusReportInfo?.activatedByFullName &&
                bonusReportInfo?.activatedByFullName?.trim() !== ''
                  ? bonusReportInfo?.activatedByFullName
                  : ('words.none' | translate)
              }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-0 fw-medium">
              {{ 'reports.bonus.canceledByFullName' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-0 fw-normal">
              {{
                bonusReportInfo?.canceledByFullName &&
                bonusReportInfo?.canceledByFullName?.trim() !== ''
                  ? bonusReportInfo?.canceledByFullName
                  : ('words.none' | translate)
              }}
            </p>
          </div>

          <div class="col-6 info-item">
            <p class="mb-0 fw-medium">
              {{ 'reports.bonus.updateBonusRegisterDate' | translate }}
            </p>
          </div>
          <div class="col-6 text-end info-item">
            <p class="mb-0 fw-normal">
              {{
                bonusReportInfo?.updatedAt
                  ? (bonusReportInfo?.updatedAt | date : FORMAT_FOR_DATES_LONG)
                  : ('words.none' | translate)
              }}
            </p>
          </div>

          <div class="col-4">
            <p class="mb-0 fw-medium">
              {{ 'reports.bonus.reasonCancellation' | translate }}
            </p>
          </div>
          <div class="col-8 text-end">
            <p class="mb-0 fw-normal">
              {{
                bonusReportInfo?.reasonCancellation || 'words.none' | translate
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="closeModal()">
    {{ 'btn.cancel' | translate }}
  </button>
</div>
